export default "__VITE_ASSET__rAKr7gaZ__"